// Arabisch (ar), hallway: het bord in de gang van een gedeelde woning (golf 6b).
export const hallwayAr = {
    thisWeek: 'على من الدور هذا الأسبوع',
    today: 'اليوم',
    cooks: '{name} يطبخ',
    nobody: 'لا أحد',
    done: 'تم',
    doneBy: 'أنجزها {name}',
    tapHint: 'المس المهمة عند إنجازها',
    whoDid: 'من قام بـ{duty}؟',
    saved: '{duty}: أنجزها {name}',
    undo: 'عفوًا، تراجع',
    undone: 'تم التراجع',
    agenda: 'أجندة البيت',
    nothingPlanned: 'لا شيء مخطط',
    close: 'إغلاق',
    allDone: 'تم كل شيء هذا الأسبوع',
    noDuties: 'لا يوجد جدول بعد. أنشئه في التطبيق من جدول المناوبة.',
};
//# sourceMappingURL=hallway.ar.js.map